import { render, staticRenderFns } from "./Gphoto.vue?vue&type=template&id=87809b10&scoped=true"
import script from "./Gphoto.vue?vue&type=script&lang=js"
export * from "./Gphoto.vue?vue&type=script&lang=js"
import style0 from "./Gphoto.vue?vue&type=style&index=0&id=87809b10&prod&lang=less&scoped=true"
import style1 from "./Gphoto.vue?vue&type=style&index=1&id=87809b10&prod&lang=css"
import style2 from "./Gphoto.vue?vue&type=style&index=2&id=87809b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87809b10",
  null
  
)

export default component.exports